import { useQuery } from '@apollo/client';
import { usePageContext } from '../../../../hooks/PageContext/usePageContext';
import { useIsTrackFeatureOn } from '../../../../hooks/useGrowthbook';
import { getUserPrefsNotificationPreferencesEligibility } from '../graphql';
import { useSettings } from '../../../../hooks/useSettings';

export const useConsumerPreferences = () => {
  const {
    state: { trackingNumbers, orderNumbers, retailerMoniker, carrier },
  } = usePageContext();

  const { notificationCenter } = useSettings();

  const { enabled: sublimeDeliveryNotifiationsEnabled } = useIsTrackFeatureOn(
    'sublime-delivery-notifications',
  );

  const { enabled: trackOnlyOptinEnabled } =
    useIsTrackFeatureOn('track-only-optin');

  // Remove this check once CPREF + Marketing Opt-in is enabled
  // Also remove skip from tests in packages/nth-pack-notification-center/__tests__/cprefMarketingNotificationCenter.spec.tsx
  // to re-enable tests
  const { marketingOptInEnabled } = notificationCenter ?? {};

  const orderNumber = orderNumbers?.[0];
  const trackingNumber = trackingNumbers?.[0];

  const skip = sublimeDeliveryNotifiationsEnabled === false;

  const { data: getUserPrefsNotificationPreferencesEligibilityData } = useQuery(
    getUserPrefsNotificationPreferencesEligibility,
    {
      skip,
      variables: {
        retailerMoniker,
        carrier,
        orderNumber,
        trackingNumber,
      },
    },
  );

  const notificationPreferencesEligible =
    getUserPrefsNotificationPreferencesEligibilityData
      ?.getUserPrefsNotificationPreferencesEligibility?.eligible ?? false;

  const orderNumberOptin = !!orderNumber && notificationPreferencesEligible;
  const trackOnlyOptin = trackOnlyOptinEnabled && !!trackingNumber && !!carrier;

  const optinEnabled =
    (orderNumberOptin || trackOnlyOptin) &&
    sublimeDeliveryNotifiationsEnabled &&
    !marketingOptInEnabled;

  return {
    optinEnabled,
  };
};
